export default function Footer() {
  const productLinks = ['BMW M Series', 'Mercedes-AMG', 'Audi Sport', 'Porsche', 'Custom Builds'];
  const companyLinks = ['About Us', 'Manufacturing', 'Quality Control', 'Careers', 'Press Kit'];
  const supportLinks = ['Installation Guides', 'Warranty Info', 'Shipping & Returns', 'Contact Support', 'FAQ'];

  return (
    <footer className="bg-black">
      {/* Trust Bar */}
      <div className="border-b border-zinc-800">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-8 py-8 md:py-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
            <div className="flex items-center gap-3 md:gap-4">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-line text-white text-xl md:text-2xl"></i>
              </div>
              <div>
                <div className="text-white text-sm md:text-base font-bold">SSL Secure</div>
                <div className="text-gray-400 text-xs md:text-sm">256-bit encryption</div>
              </div>
            </div>
            <div className="flex items-center gap-3 md:gap-4">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-arrow-go-back-line text-white text-xl md:text-2xl"></i>
              </div>
              <div>
                <div className="text-white text-sm md:text-base font-bold">Easy Returns</div>
                <div className="text-gray-400 text-xs md:text-sm">30-day guarantee</div>
              </div>
            </div>
            <div className="flex items-center gap-3 md:gap-4">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-global-line text-white text-xl md:text-2xl"></i>
              </div>
              <div>
                <div className="text-white text-sm md:text-base font-bold">Worldwide Shipping</div>
                <div className="text-gray-400 text-xs md:text-sm">40+ countries</div>
              </div>
            </div>
            <div className="flex items-center gap-3 md:gap-4">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-medal-line text-white text-xl md:text-2xl"></i>
              </div>
              <div>
                <div className="text-white text-sm md:text-base font-bold">5-Year Warranty</div>
                <div className="text-gray-400 text-xs md:text-sm">Quality guaranteed</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 py-12 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-12 mb-10 md:mb-16">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-6">
              <div className="w-11 h-11 md:w-14 md:h-14 bg-white flex items-center justify-center">
                <i className="ri-bird-fill text-black text-xl md:text-2xl"></i>
              </div>
              <div>
                <div className="text-white text-xl md:text-2xl font-black tracking-tighter">EAGLECARBON</div>
                <div className="text-gray-500 text-[10px] uppercase tracking-[2px] font-bold">Motorsport</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm md:text-base leading-relaxed mb-6 md:mb-8 max-w-md">
              Engineering excellence in carbon fiber manufacturing. Delivering race-proven performance parts for the world's most prestigious automotive brands.
            </p>
            <div className="flex items-center gap-2 md:gap-3">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 md:w-11 md:h-11 bg-zinc-900 flex items-center justify-center hover:bg-white transition-all cursor-pointer group">
                <i className="ri-instagram-line text-gray-400 group-hover:text-black text-base md:text-lg transition-colors"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 md:w-11 md:h-11 bg-zinc-900 flex items-center justify-center hover:bg-white transition-all cursor-pointer group">
                <i className="ri-facebook-fill text-gray-400 group-hover:text-black text-base md:text-lg transition-colors"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 md:w-11 md:h-11 bg-zinc-900 flex items-center justify-center hover:bg-white transition-all cursor-pointer group">
                <i className="ri-youtube-fill text-gray-400 group-hover:text-black text-base md:text-lg transition-colors"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 md:w-11 md:h-11 bg-zinc-900 flex items-center justify-center hover:bg-white transition-all cursor-pointer group">
                <i className="ri-linkedin-fill text-gray-400 group-hover:text-black text-base md:text-lg transition-colors"></i>
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-4 md:mb-6">Products</h4>
            <ul className="space-y-2 md:space-y-3">
              {productLinks.map((link) => (
                <li key={link}>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">{link}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-4 md:mb-6">Company</h4>
            <ul className="space-y-2 md:space-y-3">
              {companyLinks.map((link) => (
                <li key={link}>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">{link}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-4 md:mb-6">Support</h4>
            <ul className="space-y-2 md:space-y-3">
              {supportLinks.map((link) => (
                <li key={link}>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">{link}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Newsletter */}
        <div className="bg-zinc-900 border border-zinc-800 p-6 md:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 items-center">
            <div>
              <h3 className="text-white text-xl md:text-2xl font-bold mb-2">Stay Updated</h3>
              <p className="text-gray-400 text-sm md:text-base">
                Get exclusive product launches, technical guides, and motorsport news delivered to your inbox.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 bg-black border border-zinc-800 px-4 md:px-5 py-3 md:py-4 text-white text-sm placeholder-gray-600 focus:outline-none focus:border-white transition-colors"
              />
              <button className="bg-white px-6 md:px-8 py-3 md:py-4 text-black text-sm font-bold hover:bg-gray-200 transition-all whitespace-nowrap cursor-pointer">
                SUBSCRIBE
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-zinc-800">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-8 py-6 md:py-8">
          <div className="flex flex-col gap-5 md:gap-6">
            {/* Top row: copyright + payment */}
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="text-gray-500 text-xs md:text-sm text-center sm:text-left">
                © 2024 EagleCarbon Motorsport. All rights reserved.
              </div>
              <div className="flex items-center gap-2 md:gap-3">
                <div className="w-10 h-7 md:w-12 md:h-8 bg-white flex items-center justify-center text-xs font-bold text-black">VISA</div>
                <div className="w-10 h-7 md:w-12 md:h-8 bg-white flex items-center justify-center text-xs font-bold text-black">MC</div>
                <div className="w-10 h-7 md:w-12 md:h-8 bg-white flex items-center justify-center">
                  <i className="ri-paypal-fill text-blue-600 text-base md:text-lg"></i>
                </div>
                <div className="w-10 h-7 md:w-12 md:h-8 bg-white flex items-center justify-center text-xs font-bold text-black">AMEX</div>
              </div>
            </div>
            {/* Bottom row: policy links */}
            <div className="flex items-center justify-center sm:justify-end gap-4 md:gap-6 flex-wrap">
              <a href="#" className="text-gray-500 hover:text-white text-xs md:text-sm transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-gray-500 hover:text-white text-xs md:text-sm transition-colors cursor-pointer">Terms of Service</a>
              <a href="#" className="text-gray-500 hover:text-white text-xs md:text-sm transition-colors cursor-pointer">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
